import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface GetPredictiveModelDraftIDParams {
  readonly flowID?: string;
}

export interface GetPredictiveModelDraftIDResult extends IResult {
  draftID: string;
}

export class GetPredictiveModelDraftIDRequest extends Request<GetPredictiveModelDraftIDParams, GetPredictiveModelDraftIDResult> {
  constructor(params: GetPredictiveModelDraftIDParams) {
    super('getPredictiveModelDraftID', params);
  }
}
